/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Patient Events List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PatientEventsListView';

export const mapStateToPropsPatientEventsList = mapStateToProps;
export const mapDispatchToPropsPatientEventsList = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientEventsList,
  mapDispatchToPropsPatientEventsList
)(View);
